<template>
  <div class="ChartsDataConfigor">
    <div
      v-if="isShowStaticConfigBox"
      @mousedown="handleStaticMove"
      class="static-config-box"
      :style="getStaticConfigBoxStyle()"
    >
      <div class="header">静态数据</div>
      <div class="static-apply-and-cancel">
        <div class="confirm" @click="handleConfirmStaticConfig">应用</div>
        <div class="cancel" @click="handleCancelStaticConfig">取消</div>
      </div>
      <div class="body" @mousedown="handleMouseDownBody">
        <div class="row-control">
          <div class="colum-c-item"></div>
          <div class="row-c-item"></div>
          <div
            :class="{
              'row-c-item-outer': item2.s === ChartsDataValue.staticData.seriesList[0],
            }"
            v-for="(item2, index2) in ChartsDataValue.staticData.source"
            :key="index2"
          >
            <div
              class="row-c-item el-icon-delete"
              @click="handleDeleteColum(index2)"
              v-if="item2.s === ChartsDataValue.staticData.seriesList[0]"
            ></div>
          </div>
          <div class="plus_btn plus_btn_real el-icon-plus" @click="handleAddColum()"></div>
        </div>
        <div class="row">
          <div class="colum-c-item"></div>
          <div class="colum"></div>
          <div
            :class="{ colum: item2.s === ChartsDataValue.staticData.seriesList[0] }"
            v-for="(item2, index2) in ChartsDataValue.staticData.source"
            :key="index2"
          >
            <div class="colum" v-if="item2.s === ChartsDataValue.staticData.seriesList[0]">
              <el-input
                :disabled="disabled"
                size="mini"
                @focus="handleAxisFocus(item2.x, item2.i)"
                @input="handleAxisChange"
                v-model="item2.x"
                placeholder=""
              ></el-input>
            </div>
            <!-- <div class="colum" v-if="item2.s === ChartsDataValue.staticData.seriesList[0]">
              <el-input
                :disabled="disabled"
                size="mini"
                @focus="handleAxisFocus"
                @input="handleAxisChange"
                v-model="item2.x"
                placeholder=""
              ></el-input>
            </div> -->
          </div>
          <div class="plus_btn"></div>
        </div>
        <div class="row" v-for="(item, index) in ChartsDataValue.staticData.seriesList" :key="index">
          <div class="colum-c-item el-icon-delete" @click="handleDeleteRow(item)"></div>
          <div class="colum">
            <el-input
              :disabled="disabled"
              @focus="handleSeriesFocus"
              @input="handleSeriesChange"
              size="mini"
              v-model="ChartsDataValue.staticData.seriesList[index]"
              placeholder=""
            ></el-input>
          </div>
          <!-- 静态数据 值 -->
          <div
            :class="{ colum: item === item2.s }"
            v-for="(item2, index2) in ChartsDataValue.staticData.source"
            :key="index2"
          >
            <!-- 值 -->
            <div class="colum" v-if="item === item2.s">
              <el-input size="mini" v-model="item2.y" placeholder=""></el-input>
            </div>
          </div>
          <div
            :class="{ colum: item === item2.i }"
            v-for="(item2, index2) in ChartsDataValue.staticData.source"
            :key="index2"
          >
            <!-- 最小值 -->
            <div class="colum" v-if="item === item2.i">
              <el-input size="mini" v-model="item2.min" placeholder=""></el-input>
            </div>
          </div>
          <div
            :class="{ colum: item === item2.m }"
            v-for="(item2, index2) in ChartsDataValue.staticData.source"
            :key="index2"
          >
            <!-- 最大值 -->
            <div class="colum" v-if="item === item2.m">
              <el-input size="mini" v-model="item2.max" placeholder=""></el-input>
            </div>
          </div>
          <div :disabled="disabled" class="plus_btn"></div>
        </div>
        <div class="row">
          <div class="plus_btn plus_btn_real el-icon-plus" @click="handleAddRow"></div>
        </div>
      </div>
    </div>
    <div
      v-if="isShowApiConfigBox"
      @mousedown="handleApiMove"
      class="api-config-box"
      :style="getApiConfigBoxStyle()"
    >
      <div class="header" @click="getApiCollections">API接入</div>
      <div class="body" @mousedown="handleMouseDownBody">
        <div class="body-wrapper">
          <div class="Api-selector-and-apply">
            <div class="Api-selector">
              <el-cascader
                class="api-cascader"
                v-model="tagetApiData"
                :options="selectOptions"
                :props="props"
                @change="handleSelectApi"
              ></el-cascader>

              <!-- <el-select size="medium" v-model="selectedApiconfig" placeholder="请选择Api接入">
                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select> -->
            </div>

            <div class="Api-apply">
              <div class="confirm" @click="handleConfirmApiConfig">应用</div>
              <div class="cancel" @click="handleCancelApiConfig">取消</div>
            </div>
          </div>
          <!-- 请求基本配置 url and response accessor start-->
          <div class="Api-url-config-zone">
            <el-input
              spellcheck="false"
              class="url-input"
              v-model="showApiUrl"
              placeholder="请输入请求地址"
            ></el-input>
            <i :style="{ alignSelf: 'flex-end', color: '#fff' }">.</i>
            <el-input
              spellcheck="false"
              class="url-responce"
              v-model="ChartsDataValue.apiData.apiResponseQuery"
              placeholder="请输入请求地址"
            ></el-input>
            <div class="url-test-btn">
              <el-button type="primary" @click="doTestUrlResponse">接口测试</el-button>
            </div>
          </div>
          <!-- 请求基本配置 url and response accessor end-->

          <div class="Api-url-config-interval">
            <div class="url-methods">
              <el-select
                v-model="ChartsDataValue.apiData.apiUrlMethod"
                @change="handleApiUrlMethodChange"
                class="m-2"
                placeholder="请求方式"
              >
                <el-option
                  v-for="item in apiUrlMethods"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
            <el-checkbox v-model="ChartsDataValue.apiData.isUseInterval">自动更新请求</el-checkbox>
            <span>每</span>
            <div class="interval-seconds-input">
              <el-input v-model="ChartsDataValue.apiData.apiInterval" placeholder=""></el-input>
            </div>
            <span>秒（s）</span>
          </div>
          <!-- 是否使用user_key start -->
          <div class="Api-url-user-key">
            <el-checkbox v-model="ChartsDataValue.apiData.isUseUserKey">是否使用user_key</el-checkbox>
          </div>
          <!-- 是否使用user_key end -->
          <!-- POST请求参数传递 start -->
          <div class="Api-url-params" v-if="isShowParams">
            <div class="Api-url-header"><i></i>GET、POST参数传递</div>
            <div class="Api-url-body">
              <monaco-editor
                uni_id="Api_url_params"
                @change="handleApiUrlParamsChange"
                language="javascript"
                :codeData="ChartsDataValue.apiData.apiPostParams"
              ></monaco-editor>
            </div>
          </div>
          <!-- POST请求参数传递 end -->
          <!-- 请求结果展示区 start -->
          <div class="Api-url-response">
            <div class="Api-url-header"><i></i> <span>接口返回数据只读</span></div>
            <div class="Api-url-body">
              <monaco-editor
                uni_id="Api_url_response"
                :readOnly="true"
                language="json"
                :codeData="testUrlResponse"
              ></monaco-editor>
            </div>
          </div>
          <!-- 请求结果展示区 end -->

          <!-- 请求结果过滤器  start -->
          <div class="Api-url-filter">
            <div class="Api-url-header">
              <el-checkbox v-model="ChartsDataValue.apiData.isUseFilter">过滤器</el-checkbox>
            </div>
            <div class="Api-url-body" v-if="ChartsDataValue.apiData.isUseFilter">
              <monaco-editor
                uni_id="Api_url_filter"
                @change="handleApiUrlFilter"
                language="javascript"
                :codeData="ChartsDataValue.apiData.apiFilter"
              ></monaco-editor>

              <div class="Api-url-btn-apply" @click="doTestUrlResponse">测试</div>
            </div>
            <div class="Api-url-header" v-if="ChartsDataValue.apiData.isUseFilter">
              <i></i> 过滤结果(dataSet)只读
            </div>
            <div class="Api-url-body" v-if="ChartsDataValue.apiData.isUseFilter">
              <monaco-editor
                uni_id="Api_url_filter_result"
                @change="handleApiUrlFilterResult"
                language="json"
                :codeData="testFilterResult"
              ></monaco-editor>
            </div>
          </div>
          <!-- 请求结果过滤器  end -->
        </div>
      </div>
    </div>
    <div class="p-line"></div>
    <div class="p-lable">数据接入</div>
    <div class="p-wrap">
      <el-button
        type="default"
        :class="{
          active: ChartsDataValue.currenEntry === 'staticData',
        }"
        size="mini"
        @click="handleOpenStatic"
      >
        <i class="el-icon-link"></i>
        <span class="button-text">静态数据</span>
      </el-button>
      <el-button
        type="default"
        :class="{
          active: ChartsDataValue.currenEntry === 'apiData',
        }"
        size="mini"
        @click="handleOpenApi"
      >
        <i class="el-icon-link"></i>
        <span class="button-text">API接入</span>
      </el-button>
    </div>
    <!-- 是否使用vuex数据 -->
    <div class="vuex" v-if="ChartsDataValue?.stateData">
      <div class="v-data">使用VUEX数据</div>
      <el-switch
        v-model="ChartsDataValue.stateData.isUseStateData"
        active-color="#1989fa"
        size="mini"
        inactive-color="#333"
        @change="handleIsUseDataChange"
      >
      </el-switch>
      <!-- 数据仓库选择 -->
      <div class="pot" v-show="ChartsDataValue.stateData.isUseStateData">
        <el-select
          v-model="ChartsDataValue.stateData.dataPot"
          size="mini"
          placeholder="请选择"
          @change="handleDataPotChange"
        >
          <el-option v-for="item in pots" :key="item" :label="item" :value="item"> </el-option>
        </el-select>
      </div>
    </div>
  </div>
</template>
<script>
import MonacoEditor from '../../../views/commonviews/MonacoEditor.vue';
import { getFilterValue, getVideoStreaming } from '../../../utils/tool';
import { request } from '../../../common/request';
import Api from '../../../apis/api';
export default {
  components: { MonacoEditor },
  name: 'ChartsDataConfigor',
  /*  prop属性只读 不可直接修改 会影响性能以及维护性 */
  props: {
    CurrentConfigration: Object,
    propertyData: Object,
    propertyDataKey: String,
  },
  data() {
    return {
      isUseVuexData: false, // 是否使用vuex数据
      dataPot: '', // 使用哪个数据仓库
      pots: ['data1', 'data2', 'data3'],

      apiUrlPostParams: '', // 临时post传参
      isShowParams: false, // 是否显示传参面板
      apiUrlMethods: [
        {
          label: 'GET请求',
          value: 'get',
        },
        {
          label: 'POST请求',
          value: 'post',
        },
      ],
      selectOptions: [],
      tagetApiData: '',
      props: { expandTrigger: 'hover' },
      options: [],
      selectedApiconfig: '',
      ChartsDataValue: {},
      isShowApiConfigBox: false,
      isShowStaticConfigBox: false,
      apiConfigBoxStyle: {
        left: 0,
        top: 0,
        width: 500,
        height: 600,
      },
      staticConfigBoxStyle: {
        left: 0,
        top: 0,
        width: 600,
        height: 300,
      },
      delayTimerEditFilter: null,
      isChangeFilter: false,

      // 临时存储过滤器 监听filter改变 获取的最新值
      tempApiFilter: '',
      currentChangeAxisOldIndex: '',
      // 测试api数据的返回值
      testUrlResponse: '',
      currentModifyData: [],
      // 过滤器过滤结果
      testFilterResult: '',
      testFilterResultReadOnly: true,
      currentChangeSeriesOldValue: '',
      currentChangeAxisOldValue: '',

      addSeriesBaseNum: 1,
      addTypesBaseNum: 1,
      //是否使用用户目的地id
      showApiUrl: '',
      // 拖出的图表数据
      JudgeDataValue: {},
      disabled: false,
    };
  },
  watch: {
    // 关闭api动态配置页面清空数据
    isShowApiConfigBox(newVal) {
      if (!newVal) {
        this.testUrlResponse = '';
        this.testFilterResult = '';
      }
    },
  },
  created() {
    this.getApiCollections();
  },
  mounted() {
    /* 获取初始 静态 数值  */
    this.ChartsDataValue = this.$_.cloneDeep(this.propertyData[this.propertyDataKey].value);
    this.JudgeDataValue = this.CurrentConfigration;
    // 过滤
    this.tempApiFilter = this.ChartsDataValue.apiData.apiFilter;

    this.showApiUrl = this.ChartsDataValue.apiData.apiUrl;

    console.log(this.showApiUrl, 'api 数据值');
    this.isShowParams = this.ChartsDataValue.apiData.apiUrlMethod == 'post' ? true : true;
    this.apiUrlPostParams = this.ChartsDataValue.apiData.apiPostParams;
    // 初始化配置界面样式
    this.initBoxStyle();

    if (this.ChartsDataValue.staticData.seriesList.length > 3) {
      let base = this.ChartsDataValue.staticData.seriesList.length - 3;
      this.staticConfigBoxStyle.height += 28 * base;
    }

    let testLengthArray = [];
    this.ChartsDataValue.staticData.source.forEach(item => {
      if (item.s === this.ChartsDataValue.staticData.seriesList[0]) {
        testLengthArray.push(item);
      }
    });
    if (testLengthArray.length > 4) {
      let base = testLengthArray.length - 4;
      this.staticConfigBoxStyle.width += 80 * base;
    }
  },
  methods: {
    handleIsUseDataChange() {
      this.handleChange(this.ChartsDataValue);
    },
    // 数据仓库改变
    handleDataPotChange() {
      this.handleChange(this.ChartsDataValue);
    },
    getFilterValue(e) {
      return getFilterValue(e);
    },
    getVideoStreaming(e) {
      return getVideoStreaming(e);
    },
    handleApiUrlMethodChange(e) {
      if (e == 'post') {
        this.isShowParams = true;
      } else {
        this.isShowParams = true;
        this.ChartsDataValue.apiData.apiPostParams = '';
        // this.handleChange(this.ChartsDataValue);
      }
    },
    handleSelectApi(val) {
      console.log('-------handleSelectApi---------');
      console.log(val, 'api过滤器下拉框选择数据');
      console.log(this.tagetApiData);
      //       api_filter: "no fiter"
      // api_interval: "10"
      // api_name: "小龙湾停车场"
      // api_response_query: "data"
      // api_url: "https://restapi.amap.com/v3/weather/weatherInfo?city=%E6%9D%AD%E5%B7%9E&output=json&key=db5d2728c584e5884c385c2a509b29b9&extensions=all"
      // cate_name: ""
      // destination_param: ""
      // is_allow_use: "1"
      // is_cate: "0"
      // is_delete: "0"
      // is_use_filter: "1"
      // is_use_interval: "1"
      // key_code: ""
      // parent_row_id: "2"
      // request_method: null
      // row_id: "5"
      // use_destination: "0"
      if (val[val.length - 1]) {
        let {
          api_url,
          api_filter,
          api_interval,
          api_response_query,
          is_use_filter,
          is_use_interval,
          use_destination,
          request_method,
        } = val[val.length - 1];

        if (!api_filter) {
          api_filter = '// none filter';
        }

        // 判断是否使用 destination 参数
        if (use_destination === '1') {
          let info = window.localStorage.getItem('origin_userInfo');
          let userinfo = JSON.parse(info);
          if (info) {
            console.log('使用destination');
            this.ChartsDataValue.apiData.apiUrl = api_url + '&destination_id=' + userinfo.destination_id;
            this.showApiUrl = api_url + '&destination_id=' + userinfo.destination_id;
          } else {
            this.ChartsDataValue.apiData.apiUrl = api_url;
            this.showApiUrl = api_url;
          }
          let char = 'localhost';
          // api接口中是否有http 没有则拼接当前url
          let reg = new RegExp('http');
          if (reg.test(api_url)) {
            this.showApiUrl = `${api_url}&destination_id=${userinfo.destination_id}`;
          } else if (window.location.origin.includes(char)) {
            this.showApiUrl = `${window.location.origin}${Api.host}/gthmmc${api_url}&destination_id=${userinfo.destination_id}`;
          } else {
            this.showApiUrl = `${window.location.origin}/gthmmc${api_url}&destination_id=${userinfo.destination_id}`;
          }
        } else {
          this.ChartsDataValue.apiData.apiUrl = api_url;
          this.showApiUrl = api_url;
        }

        if (request_method) {
          this.ChartsDataValue.apiData.apiUrlMethod = request_method;
        }

        this.ChartsDataValue.apiData.apiFilter = api_filter;
        this.tempApiFilter = api_filter;
        this.ChartsDataValue.apiData.isUseFilter = is_use_filter === '1' ? true : false;
        this.ChartsDataValue.apiData.isUseInterval = is_use_interval === '1' ? true : false;
        this.ChartsDataValue.apiData.apiInterval = parseInt(api_interval);
        this.ChartsDataValue.apiData.apiResponseQuery = api_response_query;

        this.handleChange(this.ChartsDataValue);
      }
    },
    convertArrayToOptionsTree(arr) {
      let op = [];

      arr.forEach(i => {
        op.push({
          value: i,
          label: i.api_name,
          id: i.row_id,
          pid: i.parent_row_id,
          children: [],
        });
      });
    },
    getApiCollections() {
      let params = {
        method: 'get',
        url: Api.getApiCollections,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        },
      };
      // this.axios.get(this.$Api.getApiCollections)
      request(params).then(res => {
        if (res?.data?.list) {
          let rowApiList = this.$_.cloneDeep(res?.data?.list);
          let formMyTree = function formTree(arr) {
            if (!Array.isArray(arr)) {
              return [];
            }

            function init(arr) {
              arr.forEach(item => {
                item.label = item.api_name;
                item.value = item;
                item.id = parseInt(item.row_id);
                item.pid = parseInt(item.parent_row_id); //0
                if (item.is_cate === '1') {
                  item.children = [];
                }
              });
            }

            function goTree(arr) {
              console.log(arr);
              arr.forEach(item => {
                if (item.pid !== 0) {
                  let father = findFather(item.pid, arr);
                  if (father) {
                    father.children.push(item);
                  }
                }
              });
            }

            function findFather(id, arrSet) {
              let target = arrSet.find(item => item.id === id);
              if (!target) {
                arrSet.forEach(item => {
                  findFather(id, item.children);
                });
              } else {
                return target;
              }
            }

            init(arr);
            goTree(arr);
            let myTree = arr.filter(item => item.pid === 0);
            return [...myTree];
          };
          this.selectOptions = [...formMyTree(rowApiList)];
          // console.log('数据数据数据', this.selectOptions);

          // let rowCateList = [];
          // let selectOptions = [];
          // let pureApilist = [];
          // rowApiList.forEach(item => {
          //   if (item.is_cate === '1') {
          //     rowCateList.push(item);
          //   } else {
          //     pureApilist.push(item);
          //   }
          // });
          // rowCateList.forEach(item => {
          //   if (item.parent_row_id === '-1') {
          //     selectOptions.push({
          //       value: item.cate_name,
          //       label: item.cate_name,
          //       data: item,
          //       row_id: item.row_id,
          //       children: [],
          //     });
          //   }
          // });
          // selectOptions.forEach(outer => {
          //   rowCateList.forEach(inner => {
          //     if (inner.parent_row_id === outer.row_id) {
          //       outer.children.push({
          //         value: inner.cate_name,
          //         label: inner.cate_name,
          //         data: inner,
          //         row_id: inner.row_id,
          //         children: [],
          //       });
          //     }
          //   });
          // });
          // selectOptions.forEach(cate => {
          //   cate.children.forEach(subcate => {
          //     pureApilist.forEach(api => {
          //       if (api.parent_row_id === subcate.row_id) {
          //         subcate.children.push({
          //           value: api,
          //           label: api.api_name,
          //           data: api,
          //           row_id: api.row_id,
          //         });
          //       }
          //     });
          //   });
          // });
          // this.selectOptions = selectOptions;
          // console.log(rowApiList);
          // console.log(rowCateList);
          // console.log(selectOptions);
        }
      });
    },
    // 静态数据添加行
    handleAddRow() {
      // console.log('zhegge');
      let CompoName = this.JudgeDataValue.componentName.slice(0, 6);
      if (CompoName == 'Gauge1' || CompoName == 'Gauge3') {
        return;
      } else {
        let seriesKey = `新增系列${this.addSeriesBaseNum}`;
        this.addSeriesBaseNum += 1;

        let isExsit = this.ChartsDataValue.staticData.seriesList.find(item => item === seriesKey);

        // 判断是否已经存在系列名称
        if (isExsit) {
          this.handleAddRow();
          return;
        } else {
          this.ChartsDataValue.staticData.seriesList.push(seriesKey);
          let exampleList = [];
          this.ChartsDataValue.staticData.source.forEach(item => {
            if (item.s === this.ChartsDataValue.staticData.seriesList[0]) {
              exampleList.push(item);
            }
          });
          exampleList = this.$_.cloneDeep(exampleList);
          exampleList.forEach(item => {
            item.y = 0;
            item.s = seriesKey;
            this.ChartsDataValue.staticData.source.push(item);
          });

          this.handleChange(this.ChartsDataValue);

          // 判断当前行长度 如果列长度（系列数）大于3便增加静态配置界面的高度
          if (this.ChartsDataValue.staticData.seriesList.length > 3) {
            this.staticConfigBoxStyle.height += 28;
          }
        }
      }
    },
    // 静态数据添加列
    handleAddColum() {
      console.log('zhegge');
      let CompoName = this.JudgeDataValue.componentName.slice(0, 6);
      if (CompoName == 'Gauge1' || CompoName == 'Gauge3') {
        return;
      } else {
        let TypesKey = `新增类型${this.addTypesBaseNum}`;

        this.addTypesBaseNum += 1;
        let columnIndex = `列${this.addSeriesBaseNum}`;
        let isExsit = this.ChartsDataValue.staticData.source.find(item => item.x === TypesKey);
        if (isExsit) {
          this.handleAddColum();
          return;
        } else {
          let source = this.$_.cloneDeep(this.ChartsDataValue.staticData.source);
          let sort = {};
          let sortId = 0;
          this.ChartsDataValue.staticData.seriesList.forEach(item => {
            sort[`sort_${sortId}`] = {
              key: item,
              list: [],
            };
            source.forEach(item2 => {
              if (item2.s === item) {
                sort[`sort_${sortId}`].list.push(item2);
              }
            });
            sortId += 1;
          });

          for (let key in sort) {
            sort[key].list.push({ s: sort[key].key, y: 0, x: TypesKey, i: columnIndex });
          }
          let resulSeriesList = [];
          for (let key in sort) {
            resulSeriesList = [...resulSeriesList, ...sort[key].list];
          }

          this.ChartsDataValue.staticData.source = [...resulSeriesList];
          let testLengthArray = [];
          this.ChartsDataValue.staticData.source.forEach(item => {
            if (item.s === this.ChartsDataValue.staticData.seriesList[0]) {
              testLengthArray.push(item);
            }
          });

          if (testLengthArray.length > 4) {
            this.staticConfigBoxStyle.width += 80;
          }
        }
      }
    },
    // 静态数据删除行
    handleDeleteRow(s) {
      let CompoName = this.JudgeDataValue.componentName.slice(0, 6);
      if (CompoName == 'Gauge1' || CompoName == 'Gauge3') {
        return;
      } else {
        if (this.ChartsDataValue.staticData.seriesList.length < 2) {
          this.$ElMessage.error('已达到最小数据行数！');
          return;
        }
        if (this.ChartsDataValue.staticData.seriesList.length > 3) {
          this.staticConfigBoxStyle.height -= 28;
        }
        let prune = [];
        let index = this.ChartsDataValue.staticData.seriesList.findIndex(item => item === s);
        this.ChartsDataValue.staticData.seriesList.splice(index, 1);
        this.ChartsDataValue.staticData.source.forEach(item => {
          if (s !== item.s) {
            prune.push(item);
          }
        });
        this.ChartsDataValue.staticData.source = [...prune];
        this.handleChange(this.ChartsDataValue);
      }
    },
    // 景泰数据删除列
    handleDeleteColum(index) {
      let CompoName = this.JudgeDataValue.componentName.slice(0, 6);
      if (CompoName == 'Gauge1' || CompoName == 'Gauge3') {
        return;
      } else {
        let source = this.$_.cloneDeep(this.ChartsDataValue.staticData.source);
        let sort = {};
        let sortId = 0;
        this.ChartsDataValue.staticData.seriesList.forEach(item => {
          sort[`sort_${sortId}`] = {
            key: item,
            list: [],
          };
          source.forEach(item2 => {
            if (item2.s === item) {
              sort[`sort_${sortId}`].list.push(item2);
            }
          });
          sortId += 1;
        });
        for (let key in sort) {
          if (sort[key].list.length < 2) {
            this.$ElMessage.error('已达到最小数据列数！');
            return;
          }
          sort[key].list.splice(index, 1);
        }
        let resulSeriesList = [];
        for (let key in sort) {
          resulSeriesList = [...resulSeriesList, ...sort[key].list];
        }
        this.ChartsDataValue.staticData.source = [...resulSeriesList];
        let testLengthArray = [];
        this.ChartsDataValue.staticData.source.forEach(item => {
          if (item.s === this.ChartsDataValue.staticData.seriesList[0]) {
            testLengthArray.push(item);
          }
        });
        if (testLengthArray.length > 3) {
          this.staticConfigBoxStyle.width -= 80;
        }

        this.handleChange(this.ChartsDataValue);
      }
    },
    // 处理顶部类型聚焦修改
    handleAxisFocus(e, s) {
      // 记住当前值
      this.currentChangeAxisOldValue = e;
      this.currentChangeAxisOldIndex = s;
    },
    // 处理顶部类型修改
    handleAxisChange(val) {
      this.currentModifyData = JSON.parse(JSON.stringify(this.ChartsDataValue.staticData.source));
      this.currentModifyData.forEach(item => {
        if (item.x === this.currentChangeAxisOldValue && item.i === this.currentChangeAxisOldIndex) {
          item.x = val;
        }
      });

      this.currentChangeAxisOldValue = val;
      this.ChartsDataValue.staticData.source = this.currentModifyData;
      this.handleChange(this.ChartsDataValue);
    },
    // 处理顶部类型聚焦修改
    // handleAxisFocus(e) {
    //   // 记住当前值
    //   this.currentChangeAxisOldValue = e.target.value;
    // },
    // // 处理顶部类型修改
    // handleAxisChange(val) {
    //   this.ChartsDataValue.staticData.source.forEach(item => {
    //     if (item.x === this.currentChangeAxisOldValue) {
    //       item.x = val;
    //     }
    //   });
    //   this.currentChangeAxisOldValue = val;
    //   this.handleChange(this.ChartsDataValue);
    // },
    handleSeriesFocus(e) {
      this.currentChangeSeriesOldValue = e.target.value;
    },
    handleSeriesChange(val) {
      this.ChartsDataValue.staticData.source.forEach(item => {
        if (item.s === this.currentChangeSeriesOldValue) {
          item.s = val;
        }
      });
      this.currentChangeSeriesOldValue = val;
      this.handleChange(this.ChartsDataValue);
    },
    handleConfirmStaticConfig() {
      this.ChartsDataValue.currenEntry = 'staticData';
      // this.ChartsDataValue.staticData.source = this.currentModifyData;
      this.ChartsDataValue.apiData.apiFilter = this.ChartsDataValue.apiData.apiFilter.replace(/'/g, '"');

      this.handleChange(this.ChartsDataValue);
      this.isShowStaticConfigBox = false;
    },
    handleCancelStaticConfig() {
      this.isShowStaticConfigBox = false;
    },
    handleCancelApiConfig() {
      this.isShowApiConfigBox = false;
    },
    handleConfirmApiConfig() {
      if (this.isChangeFilter) {
        this.tempApiFilter = this.tempApiFilter.replace(/'/g, '"');
        this.ChartsDataValue.apiData.apiFilter = this.tempApiFilter;
        this.isChangeFilter = false;
      }
      if (this.apiUrlPostParams) {
        this.apiUrlPostParams = this.apiUrlPostParams.replace(/'/g, '"');
        this.ChartsDataValue.apiData.apiPostParams = this.apiUrlPostParams;
      }
      this.ChartsDataValue.currenEntry = 'apiData';
      this.handleChange(this.ChartsDataValue);
      this.isShowApiConfigBox = false;
    },
    handleChange(val) {
      console.log(val, 'valvalval');
      /* 更新数据 */
      this.$store.commit('update_PropertyData', {
        key: this.propertyDataKey,
        value: val,
      });
      // console.log('api 配置数据更新');
      // console.log(JSON.stringify(val));
    },
    initBoxStyle() {
      this.apiConfigBoxStyle.top = Math.round(
        this.$store.state.ClientViewSize.height / 2 - this.apiConfigBoxStyle.height / 2,
      );
      this.apiConfigBoxStyle.left = Math.round(
        this.$store.state.ClientViewSize.width / 2 - this.apiConfigBoxStyle.width / 2,
      );
      this.staticConfigBoxStyle.top = Math.round(
        this.$store.state.ClientViewSize.height / 2 - this.staticConfigBoxStyle.height / 2,
      );
      this.staticConfigBoxStyle.left = Math.round(
        this.$store.state.ClientViewSize.width / 2 - this.staticConfigBoxStyle.width / 2,
      );
    },
    handleMouseDownBody(e) {
      e.stopPropagation();
    },
    handleStaticMove(e) {
      let { left: startLeft, top: startTop } = this.staticConfigBoxStyle;
      const startY = e.clientY;
      const startX = e.clientX;
      const move = moveEvent => {
        const curX = moveEvent.clientX;
        const curY = moveEvent.clientY;
        this.staticConfigBoxStyle.top = curY - startY + startTop;
        this.staticConfigBoxStyle.left = curX - startX + startLeft;
      };
      const up = () => {
        document.removeEventListener('mousemove', move);
        document.removeEventListener('mouseup', up);
      };

      document.addEventListener('mousemove', move);
      document.addEventListener('mouseup', up);
    },
    handleApiMove(e) {
      let { left: startLeft, top: startTop } = this.apiConfigBoxStyle;
      const startY = e.clientY;
      const startX = e.clientX;
      const move = moveEvent => {
        const curX = moveEvent.clientX;
        const curY = moveEvent.clientY;
        this.apiConfigBoxStyle.top = curY - startY + startTop;
        this.apiConfigBoxStyle.left = curX - startX + startLeft;
      };
      const up = () => {
        document.removeEventListener('mousemove', move);
        document.removeEventListener('mouseup', up);
      };

      document.addEventListener('mousemove', move);
      document.addEventListener('mouseup', up);
    },
    handleOpenStatic() {
      let CompoName = this.JudgeDataValue.componentName.slice(0, 6);
      if (CompoName == 'Gauge1' || CompoName == 'Gauge3') {
        this.disabled = true;
      }
      this.isShowStaticConfigBox = true;
      this.isShowApiConfigBox = false;
    },
    handleOpenApi() {
      this.isShowApiConfigBox = true;
      this.isShowStaticConfigBox = false;
    },
    getApiConfigBoxStyle() {
      let { width, height, left, top } = this.apiConfigBoxStyle;
      return {
        width: width + 'px',
        height: height + 'px',
        left: left + 'px',
        top: top + 'px',
      };
    },
    getStaticConfigBoxStyle() {
      let { width, height, left, top } = this.staticConfigBoxStyle;
      if (height >= 527) {
        return {
          width: width + 'px',
          height: 527 + 'px',
          left: left + 'px',
          top: top + 'px',
        };
      } else {
        return {
          width: width + 'px',
          height: height + 'px',
          left: left + 'px',
          top: top + 'px',
        };
      }
      //  height: height + 'px',
    },
    doTestUrlResponse() {
      let that = this;
      if (this.isChangeFilter) {
        // this.tempApiFilter 临时存储过滤器 监听filter改变 获取的最新值
        this.ChartsDataValue.apiData.apiFilter = this.tempApiFilter;
        this.isChangeFilter = false;
      }
      // 如果是否使用用户目的地id不等于空
      if (this.showApiUrl != '') {
        // 拿到 https 一条地址
        this.ChartsDataValue.apiData.apiUrl = this.showApiUrl;
        // this.handleChange(this.ChartsDataValue);
      }
      if (this.apiUrlPostParams && this.apiUrlPostParams != '') {
        this.ChartsDataValue.apiData.apiPostParams = this.apiUrlPostParams;
      }
      // let url = this.showApiUrl == '' ? this.ChartsDataValue.apiData.apiUrl : this.showApiUrl
      // 更新数据
      this.handleChange(this.ChartsDataValue);
      let header;
      if (this.ChartsDataValue.apiData?.isUseUserKey) {
        let user_key = localStorage.getItem('user_key');

        if (user_key == 'undefined' || user_key == 'null' || user_key == null) user_key = this.$userKey;
        header = {
          userkey: user_key,
        };
      } else {
        header = {};
      }
      // this.ChartsDataValue.apiData.apiFilter = this.tempApiFilter;
      // 如果 请求方式 为get
      if (this.ChartsDataValue.apiData.apiUrlMethod == 'get') {
        let params = this.ChartsDataValue.apiData.apiPostParams || '{}';
        // 数据请求

        // this.axios({
        //   method: this.ChartsDataValue.apiData.apiUrlMethod,
        //   url: this.ChartsDataValue.apiData.apiUrl,
        //   params: eval('(' + params + ')'),
        //   headers: header,
        // })

        let param = {
          method: this.ChartsDataValue.apiData.apiUrlMethod,
          url: this.ChartsDataValue.apiData.apiUrl,
          params: eval('(' + params + ')'),
          headers: header,
        };
        request(param).then(res => {
          console.log(res, 'ssssssssssssssssss');
          // 深拷贝 res 数据
          let data = this.$_.cloneDeep(res);

          let arryQuery = this.ChartsDataValue.apiData.apiResponseQuery.split('.');
          if (arryQuery.length > 1) {
            arryQuery.forEach(item => {
              // console.log(item);
              data = data[item];
            });
          } else {
            if (arryQuery[0]) {
              data = data[arryQuery[0]];
            }
          }
          // 接口测试 api 返回值 赋值
          this.testUrlResponse = JSON.stringify(data);
          let dataSet = {};
          if (this.ChartsDataValue.apiData.isUseFilter) {
            // 将过滤的对应字符串，解析成js代码运行
            eval(this.tempApiFilter);
          }
          // 赋值给 接口返回数据只读 数据显示
          this.testFilterResult = JSON.stringify(dataSet);
          this.testFilterResultReadOnly = false;
        });
      } else {
        let params = this.ChartsDataValue.apiData.apiPostParams || '{}';

        // this.axios({
        //   method: this.ChartsDataValue.apiData.apiUrlMethod,
        //   url: this.ChartsDataValue.apiData.apiUrl,
        //   data: eval('(' + params + ')'),
        //   headers: header,
        // })

        let param = {
          method: this.ChartsDataValue.apiData.apiUrlMethod,
          url: this.ChartsDataValue.apiData.apiUrl,
          data: eval('(' + params + ')'),
          headers: header,
        };
        request(param).then(res => {
          let data = this.$_.cloneDeep(res);

          let arryQuery = this.ChartsDataValue.apiData.apiResponseQuery.split('.');
          if (arryQuery.length > 1) {
            arryQuery.forEach(item => {
              // console.log(item);
              data = data[item];
            });
          } else {
            if (arryQuery[0]) {
              data = data[arryQuery[0]];
            }
          }
          this.testUrlResponse = JSON.stringify(data);
          let dataSet = {};
          if (this.ChartsDataValue.apiData.isUseFilter) {
            eval(this.tempApiFilter);
          }
          this.testFilterResult = JSON.stringify(dataSet);
          this.testFilterResultReadOnly = false;
        });
      }
    },
    handleApiUrlParamsChange(editor) {
      console.log(editor.getValue());
      // eval("("+editor.getValue()+")")
      this.apiUrlPostParams = editor.getValue();
    },
    handleApiUrlFilter(editor) {
      console.log('handleApiUrlFilter');
      // console.log(this.$refs);
      if (typeof editor.getValue === 'function') {
        console.log(editor.getValue());
        this.tempApiFilter = editor.getValue();
        this.isChangeFilter = true;
      }
    },
    // 监听MonacoEditor内容是否更改
    handleApiUrlFilterResult(editor) {
      console.log(editor, 'editor  editor');
      editor.updateOptions({ readOnly: this.testFilterResultReadOnly });
      if (!this.testFilterResultReadOnly) {
        editor.trigger('anyString', 'editor.action.formatDocument');
        editor
          .getAction('editor.action.formatDocument')
          .run()
          .then(() => {
            this.testFilterResultReadOnly = true;
            editor.updateOptions({ readOnly: true });
          });
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
:deep().m-2 .el-input__inner {
  height: 35px;
  width: 120px;
  color: #ffffff;
  background: #000;
  text-align: center;
}

.ChartsDataConfigor {
  user-select: none;
  width: 100%;
  box-sizing: border-box;
  padding: 0 15px;
  padding-top: 20px;

  .static-config-box {
    position: fixed;
    z-index: 2001;
    background-color: $background-color-medium;
    border-radius: 6px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    /* height: 526px; */
    .header {
      height: 44px;
      line-height: 44px;
      text-align: center;
      background-color: $background-color-med;
      font-size: 14px;
      cursor: move;
    }

    .static-apply-and-cancel {
      display: flex;
      width: 100%;
      box-sizing: border-box;
      height: 70px;
      justify-content: flex-end;
      align-items: center;
      padding: 0 20px;
      font-size: 12px;

      .cancel {
        cursor: pointer;
        background-color: #0f1014;
        border: 1px solid rgb(66, 66, 66);
        padding: 5px 10px;

        &:hover {
          background: linear-gradient(143deg, #335ae9, #6f6ff5);
          border: 1px solid rgba(66, 66, 66, 0);
          color: white;
        }
      }

      .confirm {
        cursor: pointer;
        background-color: #0f1014;
        border: 1px solid rgb(66, 66, 66);
        padding: 5px 10px;
        margin-right: 20px;

        &:hover {
          background: linear-gradient(143deg, #335ae9, #6f6ff5);
          border: 1px solid rgba(66, 66, 66, 0);
          color: white;
        }
      }
    }

    .body {
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      padding: 0 20px 20px 20px;
      min-width: 527px;
      overflow-x: auto;

      &::-webkit-scrollbar-thumb {
        cursor: pointer;
        background: #2a2c99 !important;
        width: 5px !important;
        height: 3px !important;
      }

      &::-webkit-scrollbar {
        width: 5px !important;
        height: 3px !important;
      }

      &::-webkit-scrollbar-track {
        background: #43455800;
      }
      .plus_btn {
        width: 28px;
        height: 28px;
        flex-shrink: 0;
      }

      .plus_btn_real {
        box-sizing: border-box;
        line-height: 28px;
        text-align: center;
        font-weight: 1000;
        background: #2c2e3f;
        cursor: pointer;
        border: 1px solid #111;

        &:hover {
          background: linear-gradient(143deg, #335ae9, #6f6ff5);
          // border: 1px solid rgba(66, 66, 66, 0);
          color: white;
        }
      }

      .row-control {
        display: flex;
        width: 100%;

        .colum-filter-wrapper {
          display: flex;
        }

        .colum-c-item {
          flex-shrink: 0;
          width: 28px;
          line-height: 28px;
          text-align: center;
          height: 28px;
          border: 1px solid #111;
          border-collapse: collapse;
          box-sizing: border-box;
          background-color: #2c2e3f;
          color: #7b80ad;
        }

        .colum-c-item.el-icon-delete {
          cursor: pointer;

          &:hover {
            background: linear-gradient(143deg, #335ae9, #6f6ff5);
            // border: 1px solid rgba(66, 66, 66, 0);
            color: white;
          }
        }

        .row-c-item-outer {
          width: 100%;
          flex-shrink: 1;
          min-width: 80px;
        }

        .row-c-item {
          width: 100%;
          flex-shrink: 1;
          min-width: 80px;
          line-height: 28px;
          text-align: center;
          height: 28px;
          border: 1px solid #111;
          border-collapse: collapse;
          box-sizing: border-box;
          background-color: #2c2e3f;
          color: #7b80ad;
        }

        .row-c-item.el-icon-delete {
          cursor: pointer;

          &:hover {
            background: linear-gradient(143deg, #335ae9, #6f6ff5);
            // border: 1px solid rgba(66, 66, 66, 0);
            color: white;
          }
        }
      }

      .row {
        display: flex;
        // width: 100%;
        margin-left: 0;

        .colum-c-item {
          flex-shrink: 0;
          width: 28px;
          line-height: 28px;
          text-align: center;
          height: 28px;
          border: 1px solid #111;
          border-collapse: collapse;
          box-sizing: border-box;
          background-color: #2c2e3f;
          color: #7b80ad;
        }

        .colum-c-item.el-icon-delete {
          cursor: pointer;

          &:hover {
            background: linear-gradient(143deg, #335ae9, #6f6ff5);
            // border: 1px solid rgba(66, 66, 66, 0);
            color: white;
          }
        }

        .colum {
          width: 100%;
          flex-shrink: 1;
          min-width: 80px;
          height: 28px;
          font-size: 14px;
          line-height: 28px;
          text-align: center;

          :deep() input {
            color: #ffffff;
            background: #191b23;
            border-radius: 0;
            border-collapse: collapse;
            text-align: center;
            border: 1px solid #111;

            &:focus {
              border: 1px solid #3179ff;
            }
          }
        }
      }
    }
  }

  .api-config-box {
    background-color: $background-color-medium;
    border-radius: 6px;
    overflow: hidden;
    position: fixed;
    z-index: 2001;

    .header {
      height: 44px;
      line-height: 44px;
      text-align: center;
      background-color: $background-color-med;
      font-size: 14px;
      cursor: move;
    }

    .body {
      width: 100%;
      height: 556px;
      padding-bottom: 10px;

      box-sizing: border-box;

      .body-wrapper {
        width: 100%;
        height: 546px;
        overflow-y: auto;

        &::-webkit-scrollbar-thumb {
          cursor: pointer;
          background: #2a2c99 !important;
          width: 5px !important;
          height: 3px !important;
        }

        &::-webkit-scrollbar {
          width: 5px !important;
          height: 3px !important;
        }

        &::-webkit-scrollbar-track {
          background: #43455800;
        }

        .Api-selector-and-apply {
          width: 100%;
          padding: 0 30px;
          margin: 10px 0;
          display: flex;
          box-sizing: border-box;

          :deep() input {
            height: 35px;
            color: #ffffff;
            background: #000;
            text-align: center;
            // border: 1px solid rgba(139, 139, 139, 0.733);
          }

          .Api-selector {
            width: 68%;

            :deep() .api-cascader {
              width: 100% !important;
            }

            .el-select {
              width: 100%;
            }
          }

          .Api-apply {
            width: 32%;
            display: flex;
            align-items: center;
            justify-content: space-around;
            font-size: 12px;

            .cancel {
              cursor: pointer;
              background-color: #0f1014;
              border: 1px solid rgb(66, 66, 66);
              padding: 5px 10px;

              &:hover {
                background: linear-gradient(143deg, #335ae9, #6f6ff5);
                border: 1px solid rgba(66, 66, 66, 0);
                color: white;
              }
            }

            .confirm {
              cursor: pointer;
              background-color: #0f1014;
              border: 1px solid rgb(66, 66, 66);
              padding: 5px 10px;

              &:hover {
                background: linear-gradient(143deg, #335ae9, #6f6ff5);
                border: 1px solid rgba(66, 66, 66, 0);
                color: white;
              }
            }
          }
        }

        .Api-url-config-zone {
          width: 100%;
          height: 40px;
          // background-color: pink;
          box-sizing: border-box;
          padding: 0 30px;
          display: flex;
          align-items: center;

          :deep() input {
            height: 35px;
            color: #ffffff;
            background: #000;
            text-align: center;
            // border: 1px solid rgba(139, 139, 139, 0.733);
          }

          .url-input {
            font-size: 14px;
            width: 227px;
            height: 35px;
            margin-right: 2px;
          }

          .url-responce {
            margin-left: 2px;
            font-size: 14px;
            width: 65px;
            height: 35px;

            :deep() input {
              padding: 0;
            }
          }

          .url-test-btn {
            height: 35px;
            padding-top: 5px;
            margin-left: 10px;

            .el-button {
              height: 35px;
              min-height: 0px;
              width: 116px;
              border-radius: 2px;
              color: #b6b8cc;
              border: 0;
              padding: 0 15px;
              background: #2c2e3f;

              &:hover {
                background: linear-gradient(143deg, #335ae9, #6f6ff5);
                color: white;
              }
            }
          }
        }

        .Api-url-filter {
          width: 100%;

          box-sizing: border-box;
          padding: 0 30px;

          .Api-url-header {
            height: 40px;
            width: 100%;
            line-height: 30px;
            font-size: 14px;
            display: flex;
            align-items: center;

            i {
              display: inline-block;
              border-radius: 50%;
              width: 10px;
              height: 10px;
              margin-right: 5px;
              background-color: rgb(86, 88, 224);
            }
          }

          .Api-url-body {
            position: relative;
            width: 100%;
            height: 200px;

            .Api-url-btn-apply {
              cursor: pointer;
              background-color: rgba(0, 0, 0, 0.452);
              text-align: center;
              position: absolute;
              right: 14px;
              bottom: 0;
              width: 50px;
              height: 20px;
              line-height: 20px;
              font-size: 14px;
            }
          }
        }

        .Api-url-config-interval {
          width: 100%;
          height: 40px;
          padding: 0 30px;
          display: flex;
          box-sizing: border-box;
          align-items: center;
          margin-top: 10px;

          .url-methods {
            margin-right: 10px;
          }

          span {
            font-size: 12px;
            margin: 0 10px;
          }

          .interval-seconds-input {
            width: 50px;

            :deep() input {
              font-size: 12px;
              height: 28px;
              color: #ffffff;
              background: #000;
              text-align: center;
              // border: 1px solid rgba(139, 139, 139, 0.733);
            }
          }
        }

        .Api-url-user-key {
          padding: 0 30px;
          margin-top: 10px;
        }

        .Api-url-response,
        .Api-url-params {
          width: 100%;
          box-sizing: border-box;
          padding: 0 30px;

          .Api-url-header {
            height: 40px;
            width: 100%;
            line-height: 30px;
            font-size: 14px;
            display: flex;
            align-items: center;

            i {
              display: inline-block;
              border-radius: 50%;
              width: 10px;
              height: 10px;
              margin-right: 5px;
              background-color: rgb(86, 88, 224);
            }
          }

          .Api-url-body {
            width: 100%;
            height: 200px;
          }
        }
      }
    }
  }

  .p-line {
    width: 100%;
    height: 1px;
    background-image: linear-gradient(
      to left,
      rgba(204, 204, 204, 0),
      rgb(143, 143, 143),
      rgba(204, 204, 204, 0)
    );
  }

  .p-lable {
    margin-top: 10px;
    box-sizing: border-box;
    // padding: 0 15px;
    width: 100%;
    height: 30px;
    color: $property-title-color;
    font-size: $property-title-size;
    line-height: 30px;
  }

  .p-wrap {
    position: relative;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    width: 100%;
    height: 40px;
    display: flex;
    align-items: center;
    padding: 0 15px;
    justify-content: space-between;
    font-size: 14px;

    .el-button {
      height: 33px;
      border-radius: 5px;
      color: #b6b8cc;
      border: 0;
      padding: 0 15px;
      background: #2c2e3f;

      &:hover {
        background: linear-gradient(143deg, #335ae9, #6f6ff5);
        color: white;
      }

      display: flex;
      align-items: center;
    }

    .el-icon-link {
      font-size: 16px;
    }

    .active {
      background: linear-gradient(143deg, #335ae9, #6f6ff5);
      color: white;
    }
  }

  .vuex {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 5px 0;
    color: $property-attributes-color;
    font-size: $property-attributes-size;
    padding: 0 20px;
  }
}

:deep().el-switch {
  margin: auto 0;

  .el-switch__core {
    background: #55597b;
    border: none;
    height: 10px;
    width: 30px !important;

    .el-switch__action {
      top: -2px;

      background: #c9cae5;

      width: 14px;
      height: 14px;
    }
  }

  &.is-checked {
    .el-switch__core {
      background: linear-gradient(143deg, #335ae9, #6f6ff5);

      .el-switch__action {
        left: 100%;
        background: #ffffff;
        margin-left: -14px;
      }
    }
  }
}

.pot {
  .el-select {
    width: 80px;

    :deep() input {
      color: #ffffff;
      background: #191b23;
      border-radius: 0;
      border-collapse: collapse;
      text-align: center;
      border: 1px solid rgb(90, 90, 90);

      &:hover {
        border: 1px solid #3179ff;
      }

      &:focus {
        border: 1px solid #3179ff;
      }
    }
  }
}

:deep() input {
  color: #ffffff;
  background: #191b23;
  border-radius: 0;
  border-collapse: collapse;
  text-align: center;
  border: 1px solid rgb(90, 90, 90);

  &:hover {
    border: 1px solid #3179ff;
  }

  &:focus {
    border: 1px solid #3179ff;
  }
}
</style>
